import React, { useRef, useEffect } from 'react';
import classnames from '../../node_modules/classnames/index.js';
import findByType from '../../utils/findByType.js';
import SlideToggleContent from './SlideToggleContent.js';

var Toggle = function Toggle() {
  return null;
};

Toggle.displayName = "AccordionToggle";

var Panel = function Panel() {
  return null;
};

Panel.displayName = "AccordionPanel";

var PanelCard = function PanelCard(_ref) {
  var id = _ref.id,
      isOpen = _ref.isOpen,
      focusedKey = _ref.focusedKey,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      children = _ref.children,
      isFocused = _ref.isFocused;
  var ref = useRef(null);
  useEffect(function () {
    if (isFocused && ref.current !== null && id === focusedKey) {
      ref.current.focus();
    }
  }, [isFocused, focusedKey, id]);

  var renderToggle = function renderToggle() {
    var toggle = findByType(children, Toggle);

    if (!toggle) {
      return null;
    }

    return /*#__PURE__*/React.createElement("a", {
      ref: ref,
      className: classnames(toggle.props.className, isOpen && activeClassName),
      "aria-controls": id,
      "aria-expanded": isOpen,
      "aria-disabled": !isOpen,
      href: "#" + id,
      id: "accordion" + id,
      tabIndex: 0,
      onClick: function onClick(e) {
        return _onClick(e, id);
      },
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e, id);
      }
    }, toggle.props.children.type || toggle.props.children.name ? /*#__PURE__*/React.cloneElement(toggle.props.children, {
      isActive: isOpen
    }) : toggle.props.children);
  };

  var renderPanel = function renderPanel() {
    var panel = findByType(children, Panel);

    if (!panel) {
      return null;
    }

    return /*#__PURE__*/React.createElement(SlideToggleContent, {
      id: id,
      className: panel.props.className,
      isVisible: isOpen
    }, panel.props.children);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "accordion-section": "wrapper"
  }, renderToggle(), renderPanel());
};

PanelCard.displayName = "PanelCard";
PanelCard.Toggle = Toggle;
PanelCard.Panel = Panel;
PanelCard.defaultProps = {
  isOpen: false,
  onClick: null,
  onKeyDown: null,
  activeClassName: "",
  className: undefined,
  id: "",
  focusedKey: "",
  isFocused: false
};
export default PanelCard;
export { PanelCard };